import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";

// Create an axios instance with default configuration
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://82.29.162.149:8012/api/v1/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Add auth token if available
    const token = localStorage.getItem("kitchenAuthToken");
    console.log("token",token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    // Check if response is HTML instead of JSON
    const contentType = response.headers["content-type"];
    if (contentType && contentType.includes("text/html")) {
      return Promise.reject({
        status: response.status,
        message:
          "Invalid response: Received HTML instead of JSON. The API endpoint may not exist on the backend server.",
        data: null,
      });
    }

    // Return response data directly
    return response.data;
  },
  (error: AxiosError<any>) => {
    // Handle errors globally
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;

      if (status === 401) {
        // Unauthorized - clear token and redirect to login
        localStorage.removeItem("kitchenAuthToken");
        window.location.href = "/login";
      }

      return Promise.reject({
        status,
        message: data.message || "An error occurred",
        data: data,
      });
    } else if (error.request) {
      // Request made but no response received
      return Promise.reject({
        message: "No response from server. Please check your connection.",
        error: error,
      });
    } else {
      // Error in request setup
      return Promise.reject({
        message: error.message || "An error occurred",
        error: error,
      });
    }
  },
);

export default apiClient;
